import React, { useState, Dispatch } from "react";
import { useHistory } from "react-router-dom";

import { useSelector } from "react-redux";
import { RootState } from "src/redux/reducers";
import { AppLocation } from "src/redux/main/mainReducer";
import { SettingsModal } from "src/app/SettingsModal/SettingsModal";
import { openSettingsModal } from "src/app/SettingsModal/methods";
import { SettingsContext, SettingsTab } from "src/app/SettingsModal/enums";
import { SeeAsClientInfoModal } from "src/app/modals/ShareModal/SeeAsClientInfoModal/SeeAsClientInfoModal";
import { RolesInfoModal } from "src/app/modals/ShareModal/RolesInfoModal/RolesInfoModal";
import MemberOrClientModal from "src/app/modals/MemberOrClientModal/MemberOrClientModal";
import ManageFieldModal from "src/app/modals/ManageFieldModal/ManageFieldModal";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { tableDataType } from "src/app/components/Table/Table";

interface SingleProjectModalsProps {
  projectId: string;
  showAddProjectFieldModal: boolean;
  showMemberOrClientModal: boolean;
  setShowAddProjectFieldModal: Dispatch<React.SetStateAction<boolean>>;
  setShowMemberOrClientModal: Dispatch<React.SetStateAction<boolean>>;
}

export default function SingleProjectModals({
  projectId,
  showAddProjectFieldModal,
  showMemberOrClientModal,
  setShowAddProjectFieldModal,
  setShowMemberOrClientModal,
}: SingleProjectModalsProps) {
  const [showSeeAsClientInfoModal, setShowSeeAsClientInfoModal] =
    useState(false);
  const [showRulesInfoModal, setShowRolesInfoModal] = useState(false);
  const [isNewOverviewForClient, setIsNewOverviewForClient] = useState(false);

  const settingsModalData = useSelector(
    (state: RootState) => state.mainReducer.settingsModalData,
  );

  const history = useHistory();

  const openShareModal = () => {
    openSettingsModal(
      history,
      AppLocation.SingleProject,
      SettingsContext.Project,
      SettingsTab.Members,
    );
  };

  return (
    <>
      {showAddProjectFieldModal && (
        <ManageFieldModal
          onClose={() => setShowAddProjectFieldModal(false)}
          dataType={tableDataType.Project}
          title={
            <IDHFormattedMessage
              id="ws_add_overview"
              defaultMessage="Add overview"
            />
          }
          inputLabelText={
            <IDHFormattedMessage
              id="ws_overview_title"
              defaultMessage="Overview title"
            />
          }
          isNewOverviewForClient={isNewOverviewForClient}
          projectId={projectId}
        />
      )}
      {showMemberOrClientModal && (
        <MemberOrClientModal
          onClose={() => setShowMemberOrClientModal(false)}
          openRolesInfoModal={() => setShowRolesInfoModal(true)}
          setIsNewOverviewForClient={setIsNewOverviewForClient}
          showAddProjectFieldModal={() => setShowAddProjectFieldModal(true)}
        />
      )}
      {showRulesInfoModal && (
        <RolesInfoModal
          onClose={() => setShowRolesInfoModal(false)}
          openShareModal={openShareModal}
        />
      )}

      {showSeeAsClientInfoModal && (
        <SeeAsClientInfoModal
          onClose={() => setShowSeeAsClientInfoModal(false)}
          openShareModal={openShareModal}
        />
      )}
      {settingsModalData.location === AppLocation.SingleProject && (
        <SettingsModal
          members={{
            openShareModal,
            openSeeAsClientInfoModal: () => setShowSeeAsClientInfoModal(true),
            openRolesInfoModal: () => setShowRolesInfoModal(true),
          }}
          contextTargetUuid={projectId}
        />
      )}
    </>
  );
}
